import { ReactNode } from 'react';
import { useUser } from '../../hooks/useUser';

const Can = ({ permission, children, fallback = null }: { permission: string; children: ReactNode; fallback?: ReactNode }) => {
    const user = useUser();
    return <>{user.hasPermission(permission) ? children : fallback}</>;
};

export default Can;
